/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ApiLogoType,
  TempGuid,
  TenantAiInstructionConfigurationResponse,
  TenantAiStatusResponse,
  TenantExportConfigurationResponse,
  TenantResponse,
  TestAiConnectionRequest,
  TestAiConnectionResponse,
  UpdateTenantAiConfigurationRequest,
  UpdateTenantExportConfigurationRequest,
  UpdateTenantRequest,
  V1TenantAiConfigListError,
  V1TenantAiConfigTestCreateError,
  V1TenantAiConfigUpdateError,
  V1TenantAiStatusListError,
  V1TenantCssUrlUpdateError,
  V1TenantExportConfigListError,
  V1TenantExportConfigUpdateError,
  V1TenantListError,
  V1TenantLogoUpdateError,
  V1TenantUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Tenant<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantList
   * @request GET:/api/v1/tenant
   * @secure
   * @response `200` `TenantResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantList = (params: RequestParams = {}) =>
    this.http.request<TenantResponse, V1TenantListError>({
      path: `/api/v1/tenant`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantUpdate
   * @request PUT:/api/v1/tenant
   * @secure
   * @response `200` `TenantResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantUpdate = (data: UpdateTenantRequest, params: RequestParams = {}) =>
    this.http.request<TenantResponse, V1TenantUpdateError>({
      path: `/api/v1/tenant`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantLogoUpdate
   * @request PUT:/api/v1/tenant/logo
   * @secure
   * @response `200` `TempGuid` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantLogoUpdate = (
    query: {
      logoType: ApiLogoType;
    },
    data: {
      /** @format binary */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TempGuid, V1TenantLogoUpdateError>({
      path: `/api/v1/tenant/logo`,
      method: 'PUT',
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantCssUrlUpdate
   * @request PUT:/api/v1/tenant/css-url
   * @secure
   * @response `200` `TenantResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantCssUrlUpdate = (
    data: TempGuid,
    query?: {
      url?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TenantResponse, V1TenantCssUrlUpdateError>({
      path: `/api/v1/tenant/css-url`,
      method: 'PUT',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantAiStatusList
   * @summary EWM-631: Lightweight tenant AI status for the Sidebar visibility check. Returns only whether AI Advisory is enabled — no permission gate beyond auth, so non-admin (Estimator) users can render the menu item. The full `ai-config` endpoint stays admin-gated because it exposes API keys and tenant context.
   * @request GET:/api/v1/tenant/ai-status
   * @secure
   * @response `200` `TenantAiStatusResponse` OK
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantAiStatusList = (params: RequestParams = {}) =>
    this.http.request<TenantAiStatusResponse, V1TenantAiStatusListError>({
      path: `/api/v1/tenant/ai-status`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantAiConfigList
   * @summary Gets the AI configuration for the current tenant
   * @request GET:/api/v1/tenant/ai-config
   * @secure
   * @response `200` `TenantAiInstructionConfigurationResponse` OK
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantAiConfigList = (params: RequestParams = {}) =>
    this.http.request<TenantAiInstructionConfigurationResponse, V1TenantAiConfigListError>({
      path: `/api/v1/tenant/ai-config`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantAiConfigUpdate
   * @summary Updates AI instruction and enablement for the current tenant (Tenant Admin). Technical backend settings are managed in the Account Admin App.
   * @request PUT:/api/v1/tenant/ai-config
   * @secure
   * @response `200` `TenantAiInstructionConfigurationResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantAiConfigUpdate = (data: UpdateTenantAiConfigurationRequest, params: RequestParams = {}) =>
    this.http.request<TenantAiInstructionConfigurationResponse, V1TenantAiConfigUpdateError>({
      path: `/api/v1/tenant/ai-config`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantAiConfigTestCreate
   * @summary Tests the AI connection with the provided configuration
   * @request POST:/api/v1/tenant/ai-config/test
   * @secure
   * @response `200` `TestAiConnectionResponse` OK
   * @response `400` `TestAiConnectionResponse` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantAiConfigTestCreate = (data: TestAiConnectionRequest, params: RequestParams = {}) =>
    this.http.request<TestAiConnectionResponse, V1TenantAiConfigTestCreateError>({
      path: `/api/v1/tenant/ai-config/test`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantExportConfigList
   * @summary Gets the PDF/Excel export configuration for the current tenant
   * @request GET:/api/v1/tenant/export-config
   * @secure
   * @response `200` `TenantExportConfigurationResponse` OK
   * @response `401` `ProblemDetails` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantExportConfigList = (params: RequestParams = {}) =>
    this.http.request<TenantExportConfigurationResponse, V1TenantExportConfigListError>({
      path: `/api/v1/tenant/export-config`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name V1TenantExportConfigUpdate
   * @summary Updates the PDF/Excel export configuration for the current tenant
   * @request PUT:/api/v1/tenant/export-config
   * @secure
   * @response `200` `TenantExportConfigurationResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantExportConfigUpdate = (
    data: UpdateTenantExportConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<TenantExportConfigurationResponse, V1TenantExportConfigUpdateError>({
      path: `/api/v1/tenant/export-config`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
